export default "__VITE_ASSET__ByGTf1cU__"